module.exports = __webpack_public_path__ + "static/media/snow_privatization.8437eb6a.md";